var React = require('react');
var objectAssign = require('object-assign');
module.exports = function (props) {
    return React.createElement('svg', objectAssign({}, {
        viewBox: '0 0 24 24',
        version: '1.1'
    }, props), React.createElement('title', null), React.createElement('defs', null), React.createElement('g', {
        id: 'Projects',
        stroke: 'none',
        strokeWidth: '1',
        fill: 'none'
    }, React.createElement('g', {
        id: 'Homepage-Login',
        transform: 'translate(-80.000000, -424.000000)',
        fill: '#FFFFFF'
    }, React.createElement('g', {
        id: 'Facebook-Button',
        transform: 'translate(64.000000, 408.000000)'
    }, React.createElement('path', {
        d: 'M38.5818507,16 L17.3191045,16 C16.5905075,16 16,16.5904179 16,17.3191045 L16,38.5818507 C16,39.3103582 16.5905075,39.9009552 17.3191045,39.9009552 L28.766209,39.9009552 L28.766209,30.6452836 L25.6514925,30.6452836 L25.6514925,27.0381194 L28.766209,27.0381194 L28.766209,24.3779701 C28.766209,21.2908358 30.6517313,19.6098507 33.4056418,19.6098507 C34.7247463,19.6098507 35.8585672,19.7080896 36.1889254,19.7519701 L36.1889254,22.9781791 L34.2789552,22.9790746 C32.781194,22.9790746 32.4912239,23.6907463 32.4912239,24.7351045 L32.4912239,27.0381194 L36.063194,27.0381194 L35.5980597,30.6452836 L32.4912239,30.6452836 L32.4912239,39.9009552 L38.5818507,39.9009552 C39.3103582,39.9009552 39.9009552,39.3103582 39.9009552,38.5818507 L39.9009552,17.3191045 C39.9009552,16.5904179 39.3103582,16 38.5818507,16',
        id: 'Imported-Layers'
    })))));
};


//////////////////
// WEBPACK FOOTER
// ./~/react-icon-loader!./app/images/Facebook.svg
// module id = 527
// module chunks = 1